// src/pages/Payments/components/VoucherForm.tsx
import React from "react";
import CardSection from "../../../components/ui/CardSection";
import PaymentsInput from "./PaymentsInput";
import Button from "../../../components/ui/Button";
import { VoucherType, ISaleForm } from "../../../classes/interfaces";
import { ValidateVoucherResult } from "../../../services/paymentsService";
import { formatBRL } from "../../../helpers/currency.helper";
import { ApplyRow, ErrorText, SuccessText } from "./VoucherForm.styles";

interface VoucherFormProps {
  voucherCode: string;
  setFormValues: React.Dispatch<React.SetStateAction<ISaleForm>>;
  onApply: () => void;
  voucherError: string;
  voucher: ValidateVoucherResult | null;
}

function getVoucherDescription(voucher: ValidateVoucherResult | null): React.ReactNode {
  if (!voucher) return "";
  if (voucher.voucher.type === VoucherType.Delivery)
    return "Você recebeu um cupom de frete gratuito";
  return `Você recebeu um cupom de ${formatBRL(voucher.discount)}`;
}

export default function VoucherForm({
  voucherCode,
  setFormValues,
  onApply,
  voucherError,
  voucher,
}: VoucherFormProps) {
  return (
    <CardSection icon="receipt" title="Cupom de desconto" sub="Tem um cupom? Aplique aqui">
      <ApplyRow>
        <PaymentsInput
          label="Código do cupom"
          name="voucherCode"
          value={voucherCode || ""}
          onChange={setFormValues}
          maxLenght={100}
        />
        <Button variant="soft" onClick={onApply} style={{ marginTop: 21 }}>
          Aplicar
        </Button>
      </ApplyRow>
      {voucherError && <ErrorText>{voucherError}</ErrorText>}
      {voucher && <SuccessText>{getVoucherDescription(voucher)}</SuccessText>}
    </CardSection>
  );
}
